import { NomalDataModal, TransferUserDeptDataChildrenModal } from './interface';
export * from '../../TransferPersonCommon/dataTransfer';

// 用户组相关接口 将用户组信息封装为选人组件基础数据结构
export const userGroupTransferIterm = (item, language) => {
  return {
    title: language === 'en' && item.nameEn !== null ? item.nameEn : item.name,
    key: `${item.id}`,
    isLeaf: true,
    leafType: 'userGroup',
    parentKey: [{ key: 'userGroup', title: 'userGroup' }],
    iconType: 'AmuGroupOutlined',
    selectable: true,
  } as NomalDataModal;
};
const unionPath = '/wecode/service/system/scope-api-transmission'
const getrUserGroupData = (groupData, language) => {
  const tmpList = [];
  tmpList.push({
    TypeKey: 'userGroup',
    total: groupData.total,
    pageIndex: 1,
    data: groupData.list.map((item) => userGroupTransferIterm(item, language)),
  });
  return tmpList as TransferUserDeptDataChildrenModal[];
};

const getTransferUserData = (itemgroup, language) => {
  const total = itemgroup.total;
  const groupType = [];
  groupType.push({ label: language === 'en' ? 'userGroup' : '用户组', leafType: 'userGroup' });
  return {
    total,
    title: '用户组',
    key: `userGroup`,
    leafType: 'userGroup',
    groupType,
    children: getrUserGroupData(itemgroup, language),
  };
};

// 管理员相关接口
const adminTransferIterm = (item, language) => {
  return {
    title: language === 'en' && item.roleNameEn !== null ? item.roleNameEn : item.roleName,
    key: `${item.roleCode}`,
    isLeaf: true,
    leafType: 'admin',
    parentKey: [{ key: 'admin', title: 'admin' }],
    iconType: 'AmuAdministratorOutlined',
    selectable: true,
  } as NomalDataModal;
};

const getrAdminData = (adminData, language) => {
  const tmpList = [];
  tmpList.push({
    TypeKey: 'admin',
    total: adminData.length,
    pageIndex: 1,
    data: adminData.map((item) => adminTransferIterm(item, language)),
  });
  return tmpList as TransferUserDeptDataChildrenModal[];
};

export const getTransferAdminData = (itemAdmin, language) => {
  const total = itemAdmin.length;
  const groupType = [];
  groupType.push({ label: language === 'en' ? 'admin' : '管理员', leafType: 'admin' });
  return {
    total,
    title: '管理员',
    key: 'admin',
    leafType: 'admin',
    groupType,
    children: getrAdminData(itemAdmin, language),
  };
};
